import React from "react"
import { Helmet } from "react-helmet"
import slugify from "slugify"
import defaultThumb from "../images/metaimage.png"
import { Script } from "gatsby"

function getSocialCard({ title, image }) {
  if (image) {
    const ext = image.split(".").pop()
    // URL guaranteed by src/gatsby-remark-social-card

    const slugifiedTitle = slugify(title, {
      remove: /[*+~.()[\]{}'"!?/:@,]/g,
    }).toLowerCase()

    return `/social-cards/${slugifiedTitle}.${ext}`
  } else {
    return ""
  }
}

// borrowed from https://stackoverflow.com/questions/29855098/is-there-a-built-in-javascript-function-similar-to-os-path-join/46427607
function buildPath(...args) {
  return args
    .filter(Boolean)
    .map((part, i) => {
      if (i === 0) {
        return part.trim().replace(/[\/]*$/g, "")
      } else {
        return part.trim().replace(/(^[\/]*|[\/]*$)/g, "")
      }
    })
    .filter((x) => x.length)
    .join("/")
}

export default (props) => {
  const title = [
    props.title || props.pageContext?.frontmatter?.title,
    props.siteTitle,
  ]
    .filter(Boolean)
    .join(" | ")

  const description =
    props.description ||
    props.pageContext?.frontmatter?.description ||
    props.siteDescription

  const siteUrl = props.siteUrl

  const socialImage = getSocialCard({
    title: props.title || props.pageContext?.frontmatter?.title,
    image: props.image || props.pageContext?.frontmatter?.hero,
  })
  const image = buildPath(siteUrl, socialImage || defaultThumb)
  const url = buildPath(
    siteUrl,
    props.location?.pathname ? props.location.pathname : ""
  )

  const enableGumroad = process.env.GATSBY_ENABLE_GUMROAD

  return (
    <Helmet
      htmlAttributes={{
        lang: "en-us",
      }}
    >
      <title>{title}</title>
      <link rel="icon" href="/icon.png" />
      <meta name="description" content={description} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@swizec" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />{" "}
      <meta name="twitter:image" content={image} />
      <meta property="og:title" content={title} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:description" content={description} />
      {enableGumroad && (
        <>
          <Script src="https://gumroad.com/js/gumroad.js" defer />
          <Script src="https://cdn.paritydeals.com/banner.js" defer />
        </>
      )}
      <style>
        {`
div.static-tweet-embed {
    display: flex;
    flex-direction: column;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    max-width: 550px;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
    border: 1px solid rgb(196, 207, 214);
    border-radius: 12px;
    padding: 12px 16px;
    background-color: rgb(255, 255, 255);
}
div.static-tweet-embed:hover {
    background-color: rgb(247, 249, 250);
}

div.static-tweet-embed blockquote {
    margin: 0;
    font-size: 20px;
    padding: 0px;
    border: 0px;
    color: rgb(15, 20, 25);
    line-height: 24px;
}

div.static-tweet-embed blockquote a {
    color: rgb(22, 123, 185);
    cursor: pointer;
    text-decoration: none;
}

div.static-tweet-embed blockquote a:hover {
    color: rgb(27, 149, 224);
    cursor: pointer;
    text-decoration: underline;
}

div.static-tweet-embed .author {
    color: rgb(91, 112, 131);
    font-size: 15px;
    line-height: 20px;
    text-decoration: none;
    padding-bottom: 12px;
}

div.static-tweet-embed .author b {
    display: block;
    font-weight: 700;
    color: rgb(15, 20, 25);
}

div.static-tweet-embed .author b:hover {
    text-decoration: underline;
}

div.static-tweet-embed .author img {
    float: left;
    width: 48px;
    height: 48px;
    border-radius: 100%;
    margin-right: 4px;
    margin-bottom: 0px;
}

div.static-tweet-embed .media {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-content: center;
    align-items: center;
    width: 100%;
    max-height: 366px;
    margin-top: 12px;
    border-radius: 12px;
    overflow: hidden;
}

div.static-tweet-embed .media img {
    margin-bottom: 0px;
}

div.static-tweet-embed .time a {
    color: rgb(91, 112, 131);
    font-size: 15px;
    line-height: 32px;
    height: 32px;
    text-decoration: none;
}

div.static-tweet-embed .time a:hover {
    color: rgb(91, 112, 131);
    font-size: 15px;
    line-height: 32px;
    height: 32px;
    text-decoration: underline;
}

div.static-tweet-embed .stats {
    display: flex;
    align-items: center;
    color: rgb(91, 112, 131);
    font-size: 15px;
}

div.static-tweet-embed .stats svg {
    height: 20px;
    width: 20px;
    margin-right: 10px;
}

div.static-tweet-embed .stats svg path {
    fill: rgb(91, 112, 131)
}

div.static-tweet-embed .stats svg:first-child {
    padding-left: 0px;
}

div.static-tweet-embed .stats a {
    display: flex;
    align-items: center;
    margin-right: 20px;
    color: inherit;
    text-decoration: none;
}

div.static-tweet-embed .stats a.like:hover  {
    color: rgb(224, 36, 94);
    text-decoration: underline;
}

div.static-tweet-embed .stats a.like:hover svg path {
    fill: rgb(224, 36, 94);
}

div.static-tweet-embed .stats a.reply:hover  {
    color: rgb(29, 161, 242);
    text-decoration: underline;
}

div.static-tweet-embed .stats a.reply:hover svg path {
    fill: rgb(29, 161, 242);
}
`}
      </style>
    </Helmet>
  )
}
